export function useCDNImage() {
  const parsePixelString = (size: string | number | undefined): number => {
    if (typeof size === "number") {
      return size;
    }

    return parseInt(size ?? "0", 10);
  };

  return {
    parsePixelString,
  };
}
